import {
  SET_TOKEN,
  GET_USER_INFO,
  DASHBOARD_MINE,
  DASHBOARD_DETAILS,
  DASHBOARD_Zone,
  SET_NEW_ZONE,
  SET_NEW_DASHBOARD,
  UPDATE_ZONE,
  SET_DEVICE_WIDGETS_DISJOINED,
  SET_DEVICE_WIDGETS_JOINED,
  SET_ZONE_WIDGETS,
  SET_INVITATION_LIST,
  SET_INVITED_USER,
  SET_INVITED_USER_SETTING,
  SET_NEW_INVITATION,
  SET_FOLIO,
  SET_SUPPORT_TYPE_LIST,
  SET_SUPPORT_MINE,
  SELECTED_ZONE,
  SET_SCHEDULE_LIST,
  SCHEDULE_EDIT,
  SCHEDULE_DELETE,
  RELOCATE_WIDGET,
  RENAME_WIDGET,
  SET_DEVICE_MINE,
  DEVICE_RENAME,
  SET_COMMAND_GENERAL,
  RENAME_DASHBOARD,
  REMOVE_DASHBOARD,
  SELECTED_DEVICE_MINE,
  REMOVE_ZONE,
  SET_ICONS,
  SET_WIDGET_SERIAL_NUMBERS,
  UPDATE_PROFILE_INFO,
} from "./types";

export const setToken = (value) => {
  return {
    type: SET_TOKEN,
    payload: value,
  };
};

export const setUserInfo = (value) => {
  return {
    type: GET_USER_INFO,
    payload: value,
  };
};

export const setDashboardMine = (value) => {
  return {
    type: DASHBOARD_MINE,
    payload: value,
  };
};

export const setDashboardDetails = (value) => {
  return {
    type: DASHBOARD_DETAILS,
    payload: value,
  };
};

export const setDashboardZone = (value) => {
  return {
    type: DASHBOARD_Zone,
    payload: value,
  };
};

export const setNewDashboardZone = (value) => {
  return {
    type: SET_NEW_ZONE,
    payload: value,
  };
};

export const removeDashboard = (value) => {
  return {
    type: REMOVE_DASHBOARD,
    payload: value,
  };
};

export const updateZone = (value) => {
  return {
    type: UPDATE_ZONE,
    payload: value,
  };
};

export const removeZone = (value) => {
  return {
    type: REMOVE_ZONE,
    payload: value,
  };
};

export const setSelectedZone = (value) => {
  return {
    type: SELECTED_ZONE,
    payload: value,
  };
};

export const setNewDashboard = (value) => {
  return {
    type: SET_NEW_DASHBOARD,
    payload: value,
  };
};

export const setDeviceWidgetsDisjoined = (value) => {
  return {
    type: SET_DEVICE_WIDGETS_DISJOINED,
    payload: value,
  };
};

export const setDeviceWidgetsJoined = (value) => {
  return {
    type: SET_DEVICE_WIDGETS_JOINED,
    payload: value,
  };
};

export const setDeviceMine = (value) => {
  return {
    type: SET_DEVICE_MINE,
    payload: value,
  };
};

export const deviceRename = (value) => {
  return {
    type: DEVICE_RENAME,
    payload: value,
  };
};

export const setSelectedDeviceMine = (value) => {
  return {
    type: SELECTED_DEVICE_MINE,
    payload: value,
  };
};

export const setCommandGeneral = (value) => {
  return {
    type: SET_COMMAND_GENERAL,
    payload: value,
  };
};

export const setZoneWidgets = (value) => {
  return {
    type: SET_ZONE_WIDGETS,
    payload: value,
  };
};

export const setInvitationList = (value) => {
  return {
    type: SET_INVITATION_LIST,
    payload: value,
  };
};

export const setNewInvitation = (value) => {
  return {
    type: SET_NEW_INVITATION,
    payload: value,
  };
};

export const setInvitedUser = (value) => {
  return {
    type: SET_INVITED_USER,
    payload: value,
  };
};

export const setInvitedUserSetting = (value) => {
  return {
    type: SET_INVITED_USER_SETTING,
    payload: value,
  };
};

export const setFolio = (value) => {
  return {
    type: SET_FOLIO,
    payload: value,
  };
};

export const setSupportTypeList = (value) => {
  return {
    type: SET_SUPPORT_TYPE_LIST,
    payload: value,
  };
};

export const setSupportMine = (value) => {
  return {
    type: SET_SUPPORT_MINE,
    payload: value,
  };
};

export const setScheduleList = (value) => {
  return {
    type: SET_SCHEDULE_LIST,
    payload: value,
  };
};

export const scheduleEdit = (value) => {
  return {
    type: SCHEDULE_EDIT,
    payload: value,
  };
};

export const scheduleDelete = (value) => {
  return {
    type: SCHEDULE_DELETE,
    payload: value,
  };
};

export const relocateZoneWidget = (value) => {
  return {
    type: RELOCATE_WIDGET,
    payload: value,
  };
};

export const renameZoneWidget = (value) => {
  return {
    type: RENAME_WIDGET,
    payload: value,
  };
};

export const renameDashboard = (value) => {
  return {
    type: RENAME_DASHBOARD,
    payload: value,
  };
};

export const setIcons = (value) => {
  return {
    type: SET_ICONS,
    payload: value,
  };
};

export const setWidgetSerialNumbers = (value) => {
  return {
    type: SET_WIDGET_SERIAL_NUMBERS,
    payload: value,
  };
};

export const updateProfileInfo = (value) => {
  return {
    type: UPDATE_PROFILE_INFO,
    payload: value,
  };
};
